// Firebase 初始化
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB5nAxzdUolqOjdjA5KJpWTLS3G84LpWf4",
  authDomain: "randomwalk-464116.firebaseapp.com",
  projectId: "randomwalk-464116",
  storageBucket: "randomwalk-464116.firebasestorage.app",
  messagingSenderId: "358335004081",
  appId: "1:358335004081:web:bff05b1a00f16f3d1e5190",
  measurementId: "G-8DSS074QZK",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
